import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c1741c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-gray-500 my-4"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "flex items-center space-x-2"
}
const _hoisted_5 = { class: "text-gray-700" }
const _hoisted_6 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}

import { computed, onMounted, ref, watch } from "vue"
import { EyeIcon } from "@heroicons/vue/outline"

interface Props {
    modelValue?: any
    value?: any
    options: any[]
    label?: string
    description?: string
    optionLabel?: string
    optionValue?: string
    placeholder?: string
    isShowClear?: boolean
    class?: string
    panelClass?: string
    errorMessage?: string
    invalid?: boolean
    disabled?: boolean
    emptyMessage?: string
    small?: boolean
    inline?: boolean
    appendTo?: string
    required?: boolean
    isEditable?: boolean
    isShow?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsDropdown',
  props: {
    modelValue: {},
    value: {},
    options: {},
    label: {},
    description: {},
    optionLabel: {},
    optionValue: {},
    placeholder: { default: "Select Element" },
    isShowClear: { type: Boolean, default: false },
    class: {},
    panelClass: {},
    errorMessage: {},
    invalid: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    emptyMessage: {},
    small: { type: Boolean },
    inline: { type: Boolean },
    appendTo: {},
    required: { type: Boolean, default: false },
    isEditable: { type: Boolean, default: false },
    isShow: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "onChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const localModelValue = computed({
    get: () => props.modelValue || props.value,
    set: (value) => {
        emit("update:modelValue", value)
        emit("onChange", value)
    },
})

const localOptions = ref(props.options)

const localErrorMessage = ref(props.errorMessage)
const localInvalid = ref(props.invalid)
const errorStyle = computed(() =>
    localInvalid.value ? "border-red-300 placeholder-red-600 ring-1 ring-red-600 border-red-600" : ""
)
const starStyle = computed(() => [props.invalid ? "text-red-600" : "text-gray-700", "pl-1"])

const inputStyle = computed(() => (props.small ? "h-[38px] text-sm" : ""))
const getWrapperStyleInline = computed(() => (props.inline ? "flex items-center gap-4" : ""))
const getLabelStyleInline = computed(() => (props.inline ? "w-2/5" : "mb-1"))
const getInputStyleInline = computed(() => (props.inline ? "w-80" : ""))

function disableValidationError() {
    localErrorMessage.value = ""
    localInvalid.value = false
}

function filterOptions(model: string | number) {
    const { optionValue } = props
    if (typeof model === "number" || typeof model === "object") {
        return
    }

    const lowerCasedModel = model?.toLowerCase()

    if (lowerCasedModel && props.isEditable) {
        localOptions.value = props.options.filter((option) =>
            optionValue
                ? option[optionValue].toLowerCase().includes(lowerCasedModel)
                : option.toLowerCase().includes(lowerCasedModel)
        )
        return
    }
    localOptions.value = props.options
}

function getIcon(value: any) {
    return localOptions.value.find((option) => option.value === value)?.icon
}

function getLabel(value: any) {
    return localOptions.value.find((option) => option.value === value)?.label
}

function getClass(value: any) {
    return localOptions.value.find((option) => option.value === value)?.class
}

onMounted(() => {
    disableValidationError()
})

watch(
    () => props.errorMessage,
    () => {
        localErrorMessage.value = props.errorMessage
        localInvalid.value = props.invalid
    }
)

watch(
    () => props.invalid,
    () => (localInvalid.value = props.invalid)
)

watch(
    () => props.options,
    () => {
        localOptions.value = props.options
    }
)

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([props.class, getWrapperStyleInline.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass([getLabelStyleInline.value, 'text-sm font-medium text-gray-700'])
          }, _toDisplayString(_ctx.label), 3))
        : _createCommentVNode("", true),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(starStyle.value)
          }, "*", 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_Dropdown, {
      modelValue: localModelValue.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((localModelValue).value = $event)),
        filterOptions
      ],
      options: localOptions.value,
      showClear: _ctx.isShowClear,
      optionLabel: _ctx.optionLabel,
      optionValue: _ctx.optionValue,
      placeholder: _ctx.placeholder,
      class: _normalizeClass([errorStyle.value, props.class, inputStyle.value, getInputStyleInline.value]),
      panelClass: _ctx.panelClass,
      disabled: _ctx.disabled,
      emptyMessage: _ctx.emptyMessage,
      appendTo: _ctx.appendTo,
      editable: _ctx.isEditable,
      onFocus: disableValidationError
    }, _createSlots({
      option: _withCtx((slotProps) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(slotProps.option.icon), {
          class: _normalizeClass([slotProps.option.class, "mr-2 w-5 h-5"])
        }, null, 8, ["class"])),
        _createElementVNode("span", null, _toDisplayString(slotProps.option.label), 1)
      ]),
      _: 2
    }, [
      (!_ctx.optionValue)
        ? {
            name: "value",
            fn: _withCtx((slotProps) => [
              (!_ctx.isShow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "customLabel", { slotProps: slotProps })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_unref(EyeIcon), {
                      class: "h-5 w-5 text-gray-500",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("span", _hoisted_5, "Show: " + _toDisplayString(localModelValue.value), 1)
                  ]))
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "options", "showClear", "optionLabel", "optionValue", "placeholder", "class", "panelClass", "disabled", "emptyMessage", "appendTo", "editable"]),
    (localErrorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(localErrorMessage.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})